import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ExportClickedEvent,
  ExportDocumentStatus,
  ExportFacade,
  ExportListType,
  ExportType,
} from '@planone/bau365/data-access-export';
import { Observable } from 'rxjs';

@Component({
  selector: 'bau365-export-buttons',
  templateUrl: './export-buttons.component.html',
  styleUrls: ['./export-buttons.component.scss'],
})
export class ExportButtonsComponent {
  @Input() listType?: ExportListType;
  @Input() exportTypeName?: string;
  @Input() showForward?: boolean;

  @Output() exportButtonClicked: EventEmitter<ExportClickedEvent> = new EventEmitter<ExportClickedEvent>();

  status$: Observable<ExportDocumentStatus>;
  documentId$: Observable<string | undefined>;

  ExportDocumentStatus = ExportDocumentStatus;

  constructor(exportFacade: ExportFacade) {
    this.status$ = exportFacade.status$;
    this.documentId$ = exportFacade.documentId$;
  }

  export(method: ExportType, documentId?: string) {
    if (this.listType && this.exportTypeName && documentId) {
      this.exportButtonClicked.emit({
        list: this.listType,
        exportTypeName: this.exportTypeName,
        to: method,
        documentId: documentId,
      });
    }
  }
}
